const locale = {
	// #region Page layout
	NEW: 'Crea',
	COPY: ' - (COPIA)',
	// MODULE: 'Modulo: ',

	LOADING: 'Caricamento...',
	LIST_NO_ITEMS: 'Nessun risultato trovato',

	FULLSCREEN_BUTTON: 'Modalità a schermo intero',

	RECENT_ACTIVITY_TITLE: 'Azioni recenti',
	MY_NOTES_TITLE: 'Le mie note',

	NOTIFICATIONS_TITLE: 'Notifiche',
	NOTIFICATIONS_DISMISS_ALL: 'rimuovi tutte',
	NOTIFICATIONS_NONE: 'Non hai notifiche da leggere',
	NOTIFICATIONS_BUTTON: 'Notifiche',

	USER_MENU_PROFILE: 'Il mio profilo',
	USER_MENU_LOGOUT: 'Esci',

	BREADCRUMBS_DASHBOARD: 'Dashboard',
	BREADCRUMBS_DETAILS: 'Dettagli',
	BREADCRUMBS_EDIT: 'Modifica',
	BREADCRUMBS_ADD: 'Aggiungi',

	// #region Calendario
	CALENDAR_TOOLTIP_TODAY: 'Oggi',
	CALENDAR_TOOLTIP_DAY: 'Giorno',
	CALENDAR_TOOLTIP_WEEK: 'Settimana',
	CALENDAR_TOOLTIP_MONTH: 'Mese',
	CALENDAR_TOOLTIP_PREVIOUS: 'Precedente',
	CALENDAR_TOOLTIP_NEXT: 'Successivo',
	// #endregion

	SEARCH_PLACEHOLDER: 'Cerca...',
	SEARCH_BUTTON: 'Cerca',
	FILTER_BUTTON: 'Filtro',
	FILTER_QUERY_BUILDER_BUTTON: 'Filtro avanzato',
	FILTER_CLEAR_BUTTON: 'Rimuovi filtri',
	IMPORT_BUTTON: 'Importazione',
	IMPORT_FILE: 'Importa da file',
	OPEN_IN_NEW_BUTTON: 'Apri in nuova scheda',

	ORDER_DEFAULT: 'Ordine default',
	ORDER_ASCENDING: 'crescente',
	ORDER_DESCENDING: 'decrescente',

	PAGINATOR_ROWS_DISPLAYED: '{from}–{to} di {total}',
	PAGINATOR_ROWS_COUNT: '{value} righe',

	QUERY_BUILDER_PREVIEW: 'Anteprima Query SQL',

	LANGUAGE_FIELD: 'Lingua',
	LAYOUT_FIELD: 'Layout',
	THEME_FIELD: 'Tema',
	THEME_HEADER: 'Intestazione',
	THEME_PAPER: 'Sezione',
	THEME_BACKGROUND: 'Sfondo',

	MODULESEARCH_RESULTS_COUNT: '{n} di {tot} risultati',

	ADDRESS2: '{zip} {city} {district} {country}',
	VALUE: 'Valore: {value}',
	DURATION: 'Durata: {duration}',
	DURATION_EXPECTED: 'Durata prevista: {duration}',
	DURATION_HOURS: '{value} h',
	// STATUSES: 'Stati',
	// TYPES: 'Tipi',
	// OTHER: 'Altro',
	DEFAULT_VALUE: 'Default',
	DEFAULT_ITEM: 'Principale',
	UNSUBSCRIBED: 'Disiscritto',

	ACTION_EDIT: 'Modifica',
	DELETED_VALUE: 'Eliminato',
	// #endregion

	// #region Module names
	MODULE_COMPANIES_NAME: 'Aziende',
	MODULE_COMPANIES_NAME_SINGULAR: 'Azienda',
	MODULE_COMPANIES_RELATIONS_NAME: 'Tipo Relazione Azienda',
	MODULE_COMPANIES_TYPES_NAME: 'Tipo Azienda',
	MODULE_COMPANIES_SUBTYPES_NAME: 'Sottotipo Azienda',
	MODULE_COMPANIES_STATUSES_NAME: 'Stato Azienda',
	MODULE_PEOPLE_NAME: 'Persone',
	MODULE_PEOPLE_NAME_SINGULAR: 'Persona',
	MODULE_PEOPLE_STATUSES_NAME: 'Stato Persona',
	MODULE_PEOPLE_TYPES_NAME: 'Tipo Persona',
	MODULE_ITEMS_NAME: 'Prodotti',
	MODULE_ITEMS_NAME_SINGULAR: 'Prodotto',
	MODULE_ITEMS_TYPES_NAME: 'Tipo Prodotto',
	MODULE_ITEMS_UNITSOFMEASURE_NAME: 'Unità di misura',
	MODULE_ITEMS_SERIES_NAME: 'Serie Prodotto',
	MODULE_ITEMS_MEASURES_NAME: 'Misure Prodotto',
	MODULE_CHRONOLOGY_NAME: 'Cronologia',
	MODULE_CHRONOLOGY_NAME_SINGULAR: 'Evento',
	MODULE_CHRONOLOGY_STATUSES_NAME: 'Stato Evento',
	MODULE_CHRONOLOGY_TYPES_NAME: 'Tipo Evento',
	MODULE_MARKETINGACTIONS_NAME: 'Azioni Marketing',
	MODULE_MARKETINGACTIONS_NAME_SINGULAR: 'Azione Marketing',
	MODULE_MARKETINGACTIONS_STATUSES_NAME: 'Stato Azione Marketing',
	MODULE_MARKETINGACTIONS_TYPES_NAME: 'Tipo Azione Marketing',
	MODULE_COMMERCIALCAMPAIGNS_NAME: 'Campagne Commerciali',
	MODULE_COMMERCIALCAMPAIGNS_NAME_SINGULAR: 'Campagna Commerciale',
	MODULE_COMMERCIALCAMPAIGNS_STATUSES_NAME: 'Stato Campagna Commerciale',
	MODULE_COMMERCIALCAMPAIGNS_TYPES_NAME: 'Tipo Campagna Commerciale',
	MODULE_OPPORTUNITIES_NAME: 'Opportunità',
	MODULE_OPPORTUNITIES_NAME_SINGULAR: 'Opportunità',
	MODULE_OPPORTUNITIES_STATUSES_NAME: 'Stato Opportunità',
	MODULE_OPPORTUNITIES_TYPES_NAME: 'Tipo Opportunità',
	MODULE_ERP_QUOTATIONS_NAME: 'Offerte NAV',
	MODULE_ERP_QUOTATIONS_LINES_NAME: "Righe d'offerta",
	MODULE_ERP_ORDERS_NAME: 'Ordini NAV',
	MODULE_ERP_ORDERS_LINES_NAME: "Righe d'ordine",
	MODULE_CONTRACTS_NAME: 'Contratti',
	MODULE_CONTRACTS_NAME_SINGULAR: 'Contratto',
	MODULE_CONTRACTS_STATUSES_NAME: 'Stato Contratto',
	MODULE_CONTRACTS_TYPES_NAME: 'Tipo Contratto',
	MODULE_CONTRACTS_LINES_NAME: 'Righe',
	MODULE_ORDERS_NAME: 'Ordini',
	MODULE_ORDERS_NAME_SINGULAR: 'Ordine',
	MODULE_ORDERS_STATUSES_NAME: 'Stato Ordine',
	MODULE_ORDERS_TYPES_NAME: 'Tipo Ordine',
	MODULE_ORDERS_LINES_NAME: 'Righe',
	MODULE_ORDERS_BILLING_NAME: 'Programma fatturazione',
	MODULE_PROJECTS_NAME: 'Progetti',
	MODULE_PROJECTS_NAME_SINGULAR: 'Progetto',
	MODULE_PROJECTS_STATUSES_NAME: 'Stato Progetto',
	MODULE_PROJECTS_TYPES_NAME: 'Tipo Progetto',
	MODULE_ACTIVITIES_NAME: 'Attività',
	MODULE_ACTIVITIES_NAME_SINGULAR: 'Attività',
	MODULE_ACTIVITIES_STATUSES_NAME: 'Stato Attività',
	MODULE_ACTIVITIES_TYPES_NAME: 'Tipo Attività',
	MODULE_DEMS_NAME: 'DEM',
	MODULE_DEMS_NAME_SINGULAR: 'DEM',
	MODULE_DEMS_STATUSES_NAME: 'Stato DEM',
	MODULE_TICKETS_NAME: 'Ticket',
	MODULE_TICKETS_NAME_SINGULAR: 'Ticket',
	MODULE_TICKETS_STATUSES_NAME: 'Stato Ticket',
	MODULE_TICKETS_TYPES_NAME: 'Tipo Ticket',
	MODULE_WORKREPORTS_NAME: 'Rapportini',
	MODULE_WORKREPORTS_NAME_SINGULAR: 'Rapportino',
	MODULE_WORKREPORTS_STATUSES_NAME: 'Stato Rapportino',
	MODULE_WORKREPORTS_TYPES_NAME: 'Tipo Rapportino',
	MODULE_INVOICES_NAME: 'Fatture',
	MODULE_INVOICES_NAME_SINGULAR: 'Fattura',
	MODULE_INVOICES_STATUSES_NAME: 'Stato Fattura',
	MODULE_INVOICES_TYPES_NAME: 'Tipo Fattura',
	MODULE_INVOICES_DEADLINES_NAME: 'Scadenze Fattura',
	MODULE_INVOICES_DEADLINES_SINGULAR_NAME: 'Scadenza Fattura',
	MODULE_INVOICES_DEADLINES_STATUSES_NAME: 'Stato Scadenza Fattura',
	MODULE_INVOICES_DEADLINES_SUBTYPES_NAME: 'Tipo Scadenza Fattura',
	MODULE_TAGS_NAME: 'Tag',
	MODULE_MAILS_NAME: 'Indirizzi Email',
	MODULE_MAILS_NAME_SINGULAR: 'Indirizzo email',
	MODULE_PHONES_NAME: 'Numeri di telefono',
	MODULE_PHONES_NAME_SINGULAR: 'Numero di telefono',
	MODULE_PHONECALLS_NAME: 'Telefonate',
	MODULE_PHONECALLS_NAME_SINGULAR: 'Telefonata',
	MODULE_SOCIALNETWORKS_NAME: 'Social Network',
	MODULE_SOCIALNETWORKS_NAME_SINGULAR: 'Social Networks',
	MODULE_SOCIALNETWORKS_TYPES_NAME: 'Tipo Social Network',
	MODULE_WEBSITES_NAME: 'Siti Web',
	MODULE_WEBSITES_NAME_SINGULAR: 'Sito Web',
	MODULE_USERS_NAME: 'Utenti',
	MODULE_USERS_NAME_SINGULAR: 'Utente',
	MODULE_GROUPS_NAME: 'Gruppi',
	MODULE_GROUPS_NAME_SINGULAR: 'Gruppo',
	MODULE_NOTES_NAME: 'Note',
	MODULE_NOTES_NAME_SINGULAR: 'Nota',
	MODULE_DOCS_NAME: 'Documenti',
	MODULE_DOCS_NAME_RESERVED: 'Documenti riservati',
	// MODULE_FILTERS_NAME: 'Filtri',
	MODULE_SYS_LOGS_TYPES_NAME: 'Tipo Log',
	MODULE_WBS_NODES_NAME: 'Nodi WBS',
	MODULE_SYS_KPIS_NAME: 'KPI',
	MODULE_SYS_KPIS_NAME_SINGULAR: 'KPI',
	MODULE_SYS_KPIS_GOALS_NAME: 'Obiettivi KPI',
	MODULE_SYS_KPIS_GOALS_NAME_SINGULAR: 'Obiettivo KPI',
	MODULE_SYS_KPIS_GOALS_STATUSES_NAME: 'Stato Obiettivo KPI',

	MODULE_SYSTEM_TABLES_NAME: 'Tabelle di sistema',
	MODULE_MISC_NAME: 'Altro',
	MODULE_LANGUAGES_NAME: 'Lingue',
	MODULE_DISTRICTS_NAME: 'Province',
	MODULE_REGIONS_NAME: 'Regioni',
	MODULE_COUNTRIES_NAME: 'Nazioni',
	MODULE_ZONES_NAME: 'Zone',
	MODULE_LEADCHANNELS_NAME: 'Canale di Lead',
	MODULE_COMPANIES_ATECO_NAME: 'Codici ATECO',
	MODULE_COMPANIES_ATECOTYPE_NAME: 'Categorie ATECO',
	MODULE_COMPANIES_LEGALFORMS_NAME: 'Forma giuridica',
	MODULE_PRICINGGROUPS_NAME: 'Listini prezzi',
	MODULE_DISCOUNTGROUPS_NAME: 'Gruppi sconto',
	MODULE_PAYMENTMETHODS_NAME: 'Metodo di pagamento',
	MODULE_PAYMENTTERMS_NAME: 'Termini di pagamento',
	MODULE_SHIPPINGAGENTS_NAME: 'Spedizioniere',
	MODULE_SHIPPINGMETHODS_NAME: 'Metodo di spedizione',
	// #endregion

	// #region Administration tools
	RECYCLE_BIN_PAGE: 'Cestino',
	SETTINGS_PAGE: 'Impostazioni',
	LOGS_PAGE: 'Log di sistema',
	PERMISSIONS_MANAGEMENT_PAGE: 'Gestione permessi',
	EXCHAGE_MAILS_LOGS_PAGE: 'Log mail Exchange',
	// #endregion

	// #region Details tabs
	TAB_SUMMARY: 'Informazioni',
	TAB_CONTACTS: 'Contatti',
	TAB_GROUPS_USERS: 'Utenti',
	TAB_RECIPIENTS: 'Destinatari',
	TAB_LINKS: 'Click Link',
	TAB_WBS: 'WBS',
	// #endregion

	// #region Details Basic informations section
	DETAILS_INFO_SECTION: 'Informazioni base',
	DETAILS_INFO_SUBHEADER: 'Visualizza e modifica le informazioni base',
	// #endregion

	// #region Details Secondary informations section
	DETAILS_SECONDARY_INFO_SECTION: 'Informazioni aggiuntive',
	DETAILS_SECONDARY_INFO_SUBHEADER: 'Visualizza e modifica le informazioni aggiuntive',
	// #endregion

	// #region Details Description section
	DETAILS_DESCRIPTION_SECTION: 'Descrizione',
	DETAILS_DESCRIPTION_SUBHEADER: 'Visualizza e modifica la descrizione',
	// #endregion

	// #region Details Contacts section
	DETAILS_CONTACTS_MAILS_SECTION: 'Indirizzi Email',
	DETAILS_CONTACTS_PHONES_SECTION: 'Numeri di telefono',
	// #endregion

	// #region Details Source section
	DETAILS_SOURCE_SECTION: 'Fonte',
	DETAILS_SOURCE_SUBHEADER: "Visualizza e modifica la fonte dell'anagrafica",
	// #endregion

	// #region Details Flow section
	DETAILS_FLOW_SECTION: 'Flusso',
	DETAILS_FLOW_SUBHEADER: "Visualizza e modifica il flusso d'origine",
	DETAILS_FLOW_SECTION_BUTTON_ADD: 'Aggiungi nodo',

	DETAILS_FLOW_DIALOG_ADD_PARENT_TITLE: 'Aggiungi nodo padre',
	DETAILS_FLOW_FIELD_PARENT_TYPE: 'Modulo',

	DETAILS_FLOW_FIELD_MARKETINGACTION: 'Azione di Marketing padre',
	DETAILS_FLOW_FIELD_COMMERCIALCAMPAIGN: 'Campagna Commerciale padre',
	DETAILS_FLOW_FIELD_DEM: 'DEM padre',
	DETAILS_FLOW_FIELD_OPPORTUNITY: 'Opportunità padre',
	DETAILS_FLOW_FIELD_CONTRACT: 'Contratto padre',
	DETAILS_FLOW_FIELD_ORDER: 'Ordine padre',
	DETAILS_FLOW_FIELD_PROJECT: 'Progetto padre',
	DETAILS_FLOW_FIELD_ACTIVITY: 'Attività padre',
	DETAILS_FLOW_FIELD_TICKET: 'Ticket padre',
	DETAILS_FLOW_FIELD_WORKREPORT: 'Rapportino padre',
	DETAILS_FLOW_FIELD_CHRONOLOGY: 'Evento padre',
	// #endregion

	// #region Details Pricing section
	DETAILS_PRICING_SECTION: 'Pricing',
	DETAILS_PRICING_SUBHEADER: 'Visualizza e modifica i dati del pricing',
	// #endregion

	// #region Details SystemInfo section
	SYSTEMINFO_TITLE: 'Informazioni di sistema',
	SYSTEMINFO_CREATED: 'Creato il {datetime} da {user}',
	SYSTEMINFO_MODIFIED: 'Modificato il {datetime} da {user}',
	SYSTEMINFO_DELETED: 'Eliminato il {datetime} da {user}',
	SYSTEMINFO_LOG_ALERT_TITLE: 'Modalità Log',
	SYSTEMINFO_LOG_ALERT_SUBTITLE: 'Visualizza i log dei campi modificati e ripristina i valori precedenti',
	// #endregion

	// #region Details contacts
	DETAILS_PHONES_SUBHEADER: 'Visualizza i numeri di telefono associati',
	DETAILS_MAILS_SUBHEADER: 'Visualizza gli indirizzi email associati',
	DETAILS_SOCIALNETWORKS_SUBHEADER: 'Visualizza i social network associati',
	DETAILS_WEBSITES_SUBHEADER: 'Visualizza i siti web associati',
	// #endregion

	NO_FILE_UPLOADED: 'Nessun file caricato',

	// #region View items
	VIEW_TABLE_COLUMN_ACTIONS: 'Azioni',

	VIEW_TABLE_BUTTON_COLUMN_VISIBILITY: 'Gestione colonne',
	VIEW_TABLE_BUTTON_COLUMN_VISIBILITY_SHOW_ALL: 'Mostra tutte',
	VIEW_TABLE_BUTTON_COLUMN_VISIBILITY_HIDE_ALL: 'Nascondi tutte',

	// VIEW_ITEM_NO_WEBSITE: 'Nessun sito web',
	VIEW_ITEM_NO_MAIL: 'Nessun indirizzo email',
	VIEW_ITEM_NO_PHONE: 'Nessun numero di telefono',
	VIEW_ITEM_NO_COMPANY: 'Senza Azienda',
	VIEW_ITEM_NO_DESCRIPTION: 'Senza descrizione',
	VIEW_ITEM_NO_DATE: 'Data non specificata',
	VIEW_ITEM_NO_DATES: 'Periodo non specificato',
	VIEW_ITEM_NO_INTGROUP: 'Senza gruppo interno',
	VIEW_ITEM_NO_INTUSER: 'Senza utente interno assegnato',
	VIEW_ITEM_NO_EXTUSER: 'Senza utente esterno assegnato',
	VIEW_ITEM_NO_EXTREF: 'Senza referente esterno',
	VIEW_ITEM_NO_DEM: 'Senza DEM collegato',
	VIEW_ITEM_NO_OFFICE: 'Senza ufficio',
	// VIEW_ITEM_NO_LINK_TO_MAIL: 'Nessun collegamento a questa e-mail',

	VIEW_ITEM_BUTTON_MORE: 'Altro',
	VIEW_ITEM_BUTTON_EDIT: 'Modifica',
	VIEW_ITEM_BUTTON_OPEN_MAPS: 'Apri in Google Maps',
	VIEW_ITEM_BUTTON_OPEN_ALLIANZ_TRADE: 'Apri in Allianz Trade',
	// VIEW_ITEM_BUTTON_FAVOURITE: 'Aggiungi ai preferiti',
	VIEW_ITEM_BUTTON_DELETE: 'Elimina',
	VIEW_ITEM_BUTTON_REMOVE: 'Rimuovi',
	VIEW_ITEM_BUTTON_RESTORE_VALUE: 'Ripristina valore',
	VIEW_ITEM_BUTTON_ADD_COPY: 'Crea copia',
	VIEW_ITEM_BUTTON_DETAILS: 'Visualizza dettagli',
	VIEW_ITEM_BUTTON_PERMANENT_DELETE: 'Elimina definitivamente',
	VIEW_ITEM_BUTTON_RESTORE: 'Ripristina',
	VIEW_ITEM_BUTTON_DOWNLOAD: 'Scarica',
	VIEW_ITEM_BUTTON_IMAGE_EDITOR: 'Modifica Immagine',
	VIEW_ITEM_BUTTON_MOVE_UP: 'Sposta sopra',
	VIEW_ITEM_BUTTON_MOVE_DOWN: 'Sposta sotto',

	VIEW_ITEM_BUTTON_NEW_COMPANY: 'Aggiungi Azienda',
	VIEW_ITEM_BUTTON_NEW_PERSON: 'Aggiungi Persona',
	VIEW_ITEM_BUTTON_NEW_EVENT: 'Aggiungi Evento',
	VIEW_ITEM_BUTTON_NEW_MARKETINGACTION: 'Aggiungi Azione Marketing',
	VIEW_ITEM_BUTTON_NEW_COMMERCIALCAMPAIGNS: 'Aggiungi Campagna Commerciale',
	VIEW_ITEM_BUTTON_NEW_OPPORTUNITY: 'Aggiungi Opportunità',
	VIEW_ITEM_BUTTON_NEW_CONTRACT: 'Aggiungi Contratto',
	VIEW_ITEM_BUTTON_NEW_ORDER: 'Aggiungi Ordine',
	VIEW_ITEM_BUTTON_NEW_PROJECT: 'Aggiungi Progetto',
	VIEW_ITEM_BUTTON_NEW_ACTIVITY: 'Aggiungi Attività',
	VIEW_ITEM_BUTTON_NEW_TICKET: 'Aggiungi Ticket',
	VIEW_ITEM_BUTTON_NEW_WORKREPORT: 'Aggiungi Rapportino',
	VIEW_ITEM_BUTTON_NEW_DEM: 'Aggiungi DEM',
	VIEW_ITEM_BUTTON_NEW_NOTE: 'Aggiungi Nota',
	VIEW_HEADER_BUTTON_NEW_USER: 'Aggiungi Utente',
	VIEW_ITEM_BUTTON_NEW_INVOICE: 'Aggiungi Fattura',
	// VIEW_ITEM_BUTTON_NEW_ITEM: 'Aggiungi Prodotto',

	VIEW_HEADER_BUTTON_REFRESH: 'Aggiorna',
	VIEW_HEADER_BUTTON_SELECT: 'Seleziona',
	VIEW_HEADER_BUTTON_NEW: 'Nuovo record',
	// VIEW_HEADER_BUTTON_PRINT: 'Stampa',
	VIEW_HEADER_BUTTON_EXPORT: 'Genera Report',
	VIEW_HEADER_BUTTON_DOWNLOAD_CSV: 'Scarica CSV',
	// #endregion

	// #region Details headers
	DETAILS_HEADER_BUTTON_EXPORT: 'Genera Report',
	DETAILS_HEADER_BUTTON_FAVOURITE: 'Aggiungi ai preferiti',
	DETAILS_HEADER_BUTTON_DELETE: 'Elimina',
	// DETAILS_HEADER_BUTTON_EDIT: 'Modifica',
	// DETAILS_HEADER_BUTTON_UNDO: 'Annulla',
	DETAILS_HEADER_BUTTON_SHOW_LOG: 'Visualizza log',

	DETAILS_HEADER_BUTTON_SHARE: 'Condividi',

	// DETAILS_HEADER_BUTTON_NEW_COMPANY: 'Aggiungi Azienda',
	DETAILS_HEADER_BUTTON_NEW_CHILD: 'Aggiungi Sussidiaria',
	DETAILS_HEADER_BUTTON_NEW_LEAD_COMPANY: 'Aggiungi Azienda referenziata',
	DETAILS_HEADER_BUTTON_NEW_LEAD_PERSON: 'Aggiungi Persona referenziata',
	DETAILS_HEADER_BUTTON_NEW_PERSON: 'Aggiungi Persona',
	DETAILS_HEADER_BUTTON_NEW_EVENT: 'Aggiungi Evento',
	DETAILS_HEADER_BUTTON_NEW_MARKETINGACTION: 'Aggiungi Azione Marketing',
	DETAILS_HEADER_BUTTON_NEW_DEM: 'Aggiungi DEM',
	DETAILS_HEADER_BUTTON_NEW_COMMERCIALCAMPAIGN: 'Aggiungi Campagna Commerciale',
	DETAILS_HEADER_BUTTON_NEW_OPPORTUNITY: 'Aggiungi Opportunità',
	DETAILS_HEADER_BUTTON_NEW_CONTRACT: 'Aggiungi Contratto',
	DETAILS_HEADER_BUTTON_NEW_PROJECT: 'Aggiungi Progetto',
	DETAILS_HEADER_BUTTON_NEW_ACTIVITY: 'Aggiungi Attività',
	DETAILS_HEADER_BUTTON_NEW_WORKREPORT: 'Aggiungi Rapportino',
	DETAILS_HEADER_BUTTON_NEW_TICKET: 'Aggiungi Ticket',
	DETAILS_HEADER_BUTTON_NEW_INVOICE: 'Aggiungi Fattura',
	// DETAILS_HEADER_BUTTON_NEW_CALL: 'Aggiungi Chiamata',
	// DETAILS_HEADER_BUTTON_NEW_NOTE: 'Aggiungi Nota',

	DETAILS_HEADER_BUTTON_ADD_TO_COMMERCIALCAMPAIGN: 'Aggiungi a Campagna Commerciale',
	DETAILS_HEADER_BUTTON_ADD_TO_MARKETINGACTION: 'Aggiungi a Azione di Marketing',
	DETAILS_HEADER_BUTTON_ADD_TO_DEM: 'Aggiungi a DEM',

	DETAILS_TABS_CHILDREN: 'Sussidiarie',
	DETAILS_TABS_LEAD_COMPANIES: 'Aziende referenziate',
	DETAILS_TABS_LEAD_PERSON: 'Persone referenziate',
	// DETAILS_TABS_RECIPIENTS: 'Destinatari',
	// DETAILS_TAB_WBS: 'WBS',
	DETAILS_TAB_GANTT: 'Gantt Attività',
	// #endregion

	// #region Contacts
	CONTACTS_LINKED_TABLE: 'Tabella collegata',
	// #endregion

	// #region Tags
	DETAILS_TAGS_FIELD_ID: 'Codice',
	DETAILS_TAGS_FIELD_TITLE: 'Titolo',
	DETAILS_TAGS_FIELD_USER_CREATED: 'Creatore',
	DETAILS_TAGS_FIELD_DATE_CREATED: 'Data creazione',
	TAGS_ADD: 'Aggiungi',
	// #endregion

	// #region ALERT
	ALERT_UPDATING: 'Modifica...',
	ALERT_ADD_SUCCESS: 'Nuovo record aggiunto con successo!',
	ALERT_UPDATE_SUCCESS: 'Dettagli aggiornati con successo!',
	ALERT_DELETE_SUCCESS: 'Eliminazione effettuata con successo!',
	ALERT_RESTORE_SUCCESS: 'Ripristino effettuato con successo!',
	ALERT_DATA_MISSING_DATA: 'Dati mancanti!',
	ALERT_MSG_SUCCESS: 'Operazione riuscita!',
	// #endregion

	// #region DIALOGS
	DIALOG_TITLE_FILTER: 'Imposta filtro',
	DIALOG_TITLE_FILTER_DETAILS: 'Dettagli Filtro',
	DIALOG_TITLE_FILTER_SAVE: 'Salva filtro',
	DIALOG_TITLE_FILTER_LOAD: 'Carica filtro',
	DIALOG_TITLE_QUERY_BUILDER: 'Filtro avanzato',
	DIALOG_TITLE_DATERANGE: 'Data inizio 🠒 Data fine',
	DIALOG_TITLE_ADD: 'Crea {module}',
	DIALOG_TITLE_UPDATE: 'Modifica {module}',
	DIALOG_TITLE_DELETE: 'Sei sicuro di voler eliminare "{title}"?',
	DIALOG_TITLE_DELETE_GENERIC: 'Sei sicuro di voler eliminare questo elemento?',
	DIALOG_TITLE_DELETE_MULTIPLE: 'Sei sicuro di voler gli elementi selezionati?',
	DIALOG_TITLE_RESTORE: 'Sei sicuro di voler ripristinare "{title}"?',
	DIALOG_EMPTY_LIST: 'Sei sicuro di voler svuotare questa lista?',
	DIALOG_TITLE_NOTES_ADD: 'Aggiungi Nota',
	DIALOG_TITLE_NOTES_EDIT: 'Modifica Nota',
	DIALOG_TITLE_ITEMS_ADD: 'Aggiungi Prodotto',
	DIALOG_TITLE_ITEMS_EDIT: 'Modifica Prodotto',
	DIALOG_TITLE_REPORTING: 'Genera Report',
	DIALOG_TITLE_SHOW_FIELD_LOG: 'Log campo "{field}"',
	DIALOG_TITLE_RESET_PASSWORD: 'Reimposta Password',

	DIALOG_USER_PASSWORD_OLD: 'Vecchia password',
	DIALOG_USER_PASSWORD_NEW: 'Nuova password',
	DIALOG_USER_PASSWORD_CONFIRM_NEW: 'Conferma nuova password',

	DIALOG_TITLE_SHARE: 'Condividi',
	DIALOG_COPIED_ALERT: 'Copiato negli appunti!',

	DIALOG_ACTION_CLOSE: 'Chiudi',
	DIALOG_ACTION_BACK: 'Indietro',
	DIALOG_ACTION_CANCEL: 'Annulla',
	DIALOG_ACTION_CLEAR: 'Rimuovi',
	DIALOG_ACTION_NEXT: 'Continua',
	DIALOG_ACTION_SAVE: 'Salva',
	DIALOG_ACTION_ADD: 'Aggiungi',
	DIALOG_ACTION_APPLY: 'Applica',
	DIALOG_ACTION_CONFIRM: 'Conferma',
	DIALOG_ACTION_OPEN: 'Apri',
	DIALOG_ACTION_SAVE_FILTER: 'Salva filtro',
	DIALOG_ACTION_LOAD_FILTER: 'Carica filtro',
	DIALOG_ACTION_OPEN_FULL_DETAILS: 'Apri dettagli completi',
	// DIALOG_ACTION_DATE_TODAY: 'Oggi',

	DIALOG_FILTER_NAME: 'Nome filtro',
	DIALOG_FILTER_PUBLIC: 'Filtro pubblico',

	DIALOG_COMPANIES_RELATIONS_TYPE: 'Tipo Relazione Azienda',
	DIALOG_COMPANIES_RELATIONS_TYPE_CUSTOMERS: 'Clienti',
	DIALOG_COMPANIES_RELATIONS_TYPE_SUPPLIERS: 'Fornitori',
	DIALOG_COMPANIES_RELATIONS_TYPE_OTHERS: 'Altro',
	DIALOG_COMPANIES_TYPES_ID: 'Tipo Azienda',
	DIALOG_ATECO_CODE: 'Codice ATECO',
	DIALOG_ATECO_TITLE: 'Titolo',
	DIALOG_ATECO_TYPES_ID: 'Categoria ATECO',
	DIALOG_ATECO_TYPES_TITLE: 'Titolo',

	DIALOG_LEGAL_FORM_CODE: 'Sigla',
	DIALOG_LEGAL_FORM_TITLE: 'Tipo di società',

	DIALOG_DISTRICTS_TITLE: 'Nome Provincia',
	DIALOG_DISTRICTS_ISO: 'Codice ISO',
	DIALOG_DISTRICTS_REGION: 'Regione',
	DIALOG_REGIONS_TITLE: 'Nome Regione',
	DIALOG_REGIONS_ISO: 'Codice ISO',
	DIALOG_REGIONS_COUNTRY: 'Nazione',
	DIALOG_COUNTRIES_TITLE: 'Nome Nazione',
	DIALOG_COUNTRIES_ISO: 'Codice ISO',
	DIALOG_COUNTRIES_GROUP: 'Gruppo Nazione',
	DIALOG_COUNTRIES_GROUP_CEE: 'CEE',
	DIALOG_COUNTRIES_GROUP_EXTRA_CEE: 'Extra CEE',

	DIALOG_SOCIAL_NETWORK_TYPES_ICON: 'Icona',

	DIALOG_INVOICES_TYPES_GROUP: 'Categoria Tipo Fattura',
	DIALOG_INVOICES_TYPES_GROUP_INCOMES: 'Entrate',
	DIALOG_INVOICES_TYPES_GROUP_EXPENSES: 'Uscite',
	DIALOG_INVOICES_TYPES_CREDITNOTE: 'Nota di credito',

	DIALOG_PROJECTS_TYPES_WBSMODEL: 'Modello WBS',

	DIALOG_REPLACE_NULL: 'Sostituisci con valore vuoto',
	DIALOG_REPLACE: 'Sostituisci con',

	// DIALOG_REFRESH_COORDINATES: 'Aggiorna coordinate',
	// DIALOG_SEARCH_COORDINATES: 'Cerca coordinate',

	// DIALOG_MAILS_TITLE: 'Indirizzo Email',
	// DIALOG_PHONES_TITLE: 'Numero di telefono',
	// DIALOG_SOCIALNETWORKS_TITLE: 'Social Network',

	DIALOG_TITLE_ADD_TO: 'Aggiungi a',

	DIALOG_LOGO_TITLE: 'Cambia avatar',
	DIALOG_LOGO_UPLOAD: 'Carica',
	DIALOG_LOGO_UPLOAD_DESCRIPTION: "Carica un'immagine dal tuo dispositivo",
	DIALOG_LOGO_FIND: 'Cerca su Google',
	DIALOG_LOGO_FIND_DESCRIPTION: "Cerca un'immagine tramite Google Immagini e caricala nell'anagrafica corrente",

	DIALOG_IMAGE_EDITOR: 'Editor Immagini',
	IMAGE_RESIZER_WIDTH: 'Larghezza',
	IMAGE_RESIZER_HEIGHT: 'Altezza',
	// DIALOG_COORDINATES_DESCRIPTION:
	// 	"Inserisci o aggiorna a le coordinate di questo indirizzo, ricorda che consumerai una delle 250k chiamate mensili se premi 'Conferma'",

	// DIALOG_UPLOAD_BUSNINESS_CARD_TITLE: 'Carica Immagini Biglietti da Visita',
	// #endregion

	// #region COMMON
	// YES: 'Sì',
	// NO: 'No',
	DIVIDER_OR: 'O',
	// #endregion

	// #region HTML Editor
	HTMLEDITOR_BOLD: 'Grassetto',
	HTMLEDITOR_ITALIC: 'Italico',
	HTMLEDITOR_UNDERLINE: 'Sottolineato',
	HTMLEDITOR_STRIKETHROUGH: 'Barrato',
	HTMLEDITOR_H1: 'Titolo 1',
	HTMLEDITOR_H2: 'Titolo 2',
	HTMLEDITOR_H3: 'Titolo 3',
	HTMLEDITOR_P: 'Paragrafo',
	HTMLEDITOR_NUMBEREDLIST: 'Elenco numerato',
	HTMLEDITOR_BULLETEDLIST: 'Elenco puntato',
	HTMLEDITOR_ADDLINK: 'Aggiungi link',
	HTMLEDITOR_START_STT: 'Avvia dettatura',
	HTMLEDITOR_STOP_STT: 'Ferma dettatura',
	HTMLEDITOR_UNDO: 'Annulla',
	HTMLEDITOR_REDO: 'Ripeti',
	// #endregion

	// #region Prompt texts
	PROMPT_TEXT_UNSAVED: 'Ci sono modifiche non salvate. Sei sicuro di voler uscire?',
	// #endregion

	// #region File viewer
	FILE_EXPLORER_UPLOAD_FILE: 'Carica file',
	FILE_EXPLORER_COLUMN_NAME: 'Nome',
	FILE_EXPLORER_COLUMN_TYPE: 'Tipo',
	FILE_EXPLORER_COLUMN_LAST_MODIFIED: 'Ultima modifica',
	FILE_EXPLORER_COLUMN_SIZE: 'Dimensioni',
	FILE_EXPLORER_EMPTY_FOLDER: 'La cartella è vuota.',
	FILE_EXPLORER_FILE_DIALOG_SUBTITLE: 'Dimensioni: {size} - Ultima modifica: {date}',
	FILE_VIEWER_NOT_SUPPORTED: 'La visualizzazione del formato .{fileType} non è supportata.',
	// #endregion

	// #region Mail Viewer
	MAIL_INBOUND: 'Ricevuta',
	MAIL_OUTBOUND: 'Inviata',
	MAIL_SUBJECT: 'Oggetto',
	MAIL_FROM: 'Da',
	MAIL_TO: 'A',
	MAIL_DATE_SENT: 'Data invio',
	MAIL_DATE_RECEIVED: 'Data ricezione',
	// #endregion

	// #region Validation messages
	ERROR_TEXT_REQUIRED: 'Campo obbligatorio',
	ERROR_TEXT_MAXLENGTH: 'La lunghezza massima consentita dal campo è stata superata',
	ERROR_TEXT_PHONE: 'Numero di telefono non valido',
	ERROR_TEXT_EMAIL: 'Email non valida',
	ERROR_MIN_VALUE: 'Il valore non può essere minore di {{value}}',
	ERROR_MAX_VALUE: 'Il valore non può essere maggiore di {{value}}',
	ERROR_MIN_CURRENCY: 'Il valore non può essere minore di {{value, currency}}',
	ERROR_MAX_CURRENCY: 'Il valore non può essere maggiore di {{value, currency}}',
	ERROR_MIN_DATE: 'La data non può essere prima del {value}',
	ERROR_MAX_DATE: 'La data non può essere dopo il {value}',
	ERROR_MIN_TIME: "L'orario non può essere prima delle {value}",
	ERROR_MAX_TIME: "L'orario non può essere dopo alle {value}",
	ERROR_NUMBER_ONLY_INT: 'Valori decimali non consentiti',
	ERROR_TEXT_NO_DUPLICATED_CAMPAIGNS:
		'I campi "Azione Marketing padre" e "Campagna Commerciale padre" non possono essere entrambi compilati',
	// ERROR_TEXT_TIME: 'Formato tempo non valido',
	ERROR_IMAGE_NOT_AVAILABLE: 'Immagine non disponibile.',
	ERROR_FILE_READ: 'Errore durante la lettura del file.',
	ERROR_FILE_VIDEO_NOT_SUPPORTED: 'La riproduzione dei video non è supportata dal browser corrente.',
	ERROR_FILE_AUDIO_NOT_SUPPORTED: 'La riproduzione di file audio non è supportata dal browser corrente.',
	// ERROR_VALUE_TOO_HIGH: 'Il valore inserito è troppo grande.',
	// ERROR_VALUE_TOO_LOW: 'Il valore inserito è troppo piccolo.',
	// ERROR_DATE_TOO_LATE: 'La data è posta troppo tardi',
	// ERROR_DATE_TOO_EARLY: 'La data è posta troppo presto.',
	ERROR_PASSWORD_NO_MATCH: 'Le password non corrispondono',
	ERROR_WRONG_USER_OR_PASSWORD: 'Utente o password errati',
	ERROR_NEW_PASSWORD_MATCH_OLD: 'La nuova password non può esser uguale alla vecchia password',
	ERROR_FILTER_SAVE_EMPTY: 'Devi impostare almeno un filtro per poterlo salvare',
	// #endregion

	// #region Details Notes section
	NOTES_SECTION: 'Note',
	NOTES_SUBHEADER: 'Visualizza e modifica le note',
	// #endregion

	// #region Reporting components
	REPORTING_STEP_TEMPLATE: 'Seleziona il template',
	REPORTING_STEP_PARAMETERS: 'Modifica i parametri',
	REPORTING_STEP_RESULT: 'Visualizza il risultato',
	REPORTING_FIELD_FILENAME: 'Nome File',
	REPORTING_FIELD_FILEFORMAT: 'Formato Esportazione',
	REPORTING_BUTTON_VIEW: 'Visualizza',
	REPORTING_BUTTON_DOWNLOAD: 'Scarica',
	// #endregion

	// #region Documents settings dialog
	DETAILS_HEADER_BUTTON_DOCUMENTS_SETTINGS: 'Configurazione documenti',
	DOCUMENTS_SETTINGS_DIALOG_TITLE: 'Configurazione documenti',
	DOCUMENTS_SETTINGS_DIALOG_CURRENTPATH: 'Percorso corrente',
	DOCUMENTS_SETTINGS_DIALOG_DESCRIPTION1:
		'Utilizza il campo "Nome cartella" per cambiare la cartella dove vengono salvati i documenti.',
	DOCUMENTS_SETTINGS_DIALOG_DESCRIPTION2:
		'ATTENZIONE: i documenti già esistenti rimarranno nella cartella precedente e dovranno essere spostati a mano nel nuovo percorso.',
	DOCUMENTS_SETTINGS_DIALOG_FIELD_FOLDERNAME: 'Nome cartella',
	// #endregion

	// #region Date range filter
	DATERANGE_FILTER_PRESET: 'Intervallo',

	DATERANGE_PRESET_CUSTOM: 'Custom',
	DATERANGE_PRESET_LASTSEVENDAYS: 'Negli scorsi 7 giorni',
	DATERANGE_PRESET_NEXTSEVENDAYS: 'Nei prossimi 7 giorni',
	DATERANGE_PRESET_LASTWEEK: 'Settimana scorsa',
	DATERANGE_PRESET_CURRENTWEEK: 'Settimana corrente',
	DATERANGE_PRESET_NEXTWEEK: 'Settimana prossima',
	DATERANGE_PRESET_LASTMONTH: 'Mese scorso',
	DATERANGE_PRESET_CURRENTMONTH: 'Mese corrente',
	DATERANGE_PRESET_NEXTMONTH: 'Mese prossimo',
	DATERANGE_PRESET_LASTYEAR: 'Anno scorso',
	DATERANGE_PRESET_CURRENTYEAR: 'Anno corrente',
	DATERANGE_PRESET_NEXTYEAR: 'Anno prossimo',
	// #endregion

	// #region WBS
	WBS_DURATION: 'Durata prevista: {value} ora/e',

	WBS_SECTION_NEW_TITLE: 'Work Breakdown Structure (WBS)',
	WBS_SECTION_NEW_SUBHEADER: 'Clicca il bottone "Crea" a destra per associare una WBS a questo elemento',

	WBS_TITLE: 'Editor WBS',
	WBS_HELPTEXT:
		'Seleziona un nodo per vederne i dettagli e poterlo modificare. Puoi espandere o ridurre un ramo utilizzando la freccetta alla sinistra del nome o aggiungere un nodo premendo il tasto "+".',
	WBS_HELPTEXT_WARNING:
		'ATTENZIONE: non è possibile aggiungere nodi ad una foglia o trasformare un ramo contenente altri nodi in una foglia.',

	WBS_NEW_NODE_TITLE: 'Nuovo nodo',
	WBS_ADD_NODE_BUTTON: 'Aggiungi nodo',

	WBS_NODES_FIELD_TITLE: 'Titolo',
	WBS_NODES_FIELD_DESCRIPTION: 'Descrizione',
	WBS_NODES_FIELD_TYPE: 'Tipologia nodo',
	WBS_NODES_FIELD_TYPE_BRANCH: 'Ramo',
	WBS_NODES_FIELD_TYPE_LEAF: 'Foglia',
	WBS_NODES_FIELD_ORDER: 'Ordine',
	WBS_NODES_FIELD_ACTIVITY_TYPE: 'Tipo Attività',
	WBS_NODES_FIELD_DATE_FROM_EXPECTED: 'Data inizio previsto',
	WBS_NODES_FIELD_DATE_TO_EXPECTED: 'Data fine prevista',
	WBS_NODES_FIELD_INHERIT_USER_ASSIGNED: 'Eredita Utente assegnato da padre',
	WBS_NODES_FIELD_USER_ASSIGNED: 'Utente assegnato',
	WBS_NODES_FIELD_HOURS_EXPECTED: 'Ore previste',

	DETAILS_WBS_MODELS_FIELD_TITLE: 'Titolo',
	DETAILS_WBS_MODELS_FIELD_DESCRIPTION: 'Descrizione',
	DETAILS_WBS_MODELS_FIELD_WARNING: 'Warning',
	DETAILS_WBS_MODELS_FIELD_BLOCKED: 'Bloccato',

	WBS_DIALOG_ACTION_SAVE_MODEL: 'Salva modello',
	WBS_DIALOG_ACTION_LOAD_MODEL: 'Carica modello',
	WBS_DIALOG_ACTION_GENERATE_ACTIVITIES: 'Genera Attività',
	// #endregion

	// #region Lines
	TOT_VALUE_TAX_EXCLUDED: 'Prezzo totale (tasse escluse): {value}',
	TOT_VALUE_TAX_INCLUDED: 'Prezzo totale (tasse incluse): {value}',
	TOT_VALUE_TAX_EXCLUDED_PROMOS_DISCOUNT: 'Prezzo totale (tasse escluse) comprensivo di extrasconto: {value}',
	TOT_EXPENSES: 'Costo totale: {value}',
	TOT_MERCH_POINTS: 'Totale Punti Merchandise: {value}',
	LINES_ISGIFT: 'Regalo',
	// #endregion

	// #region Postpone dialog
	VIEW_ITEM_BUTTON_POSTPONE: 'Posponi',
	DIALOG_TITLE_POSTPONE: 'Sei sicuro di voler posporre di 10 giorni la data di fine?',
	// #endregion

	// #region Documents templates dialog
	VIEW_ITEM_BUTTON_GENERATE_DOCUMENT: 'Genera documento',

	DOCUMENT_TEMPLATES_FIELD_TITLE: 'Nome template',
	DOCUMENT_TEMPLATES_FIELD_DESCRIPTION: 'Descrizione template',
	DOCUMENT_TEMPLATES_FIELD_MODULE: 'Modulo',
	DOCUMENT_TEMPLATES_FIELD_FILENAME_TEMPLATE: 'Nome documento generato',
	DOCUMENT_TEMPLATES_FIELD_VIEWNAME: 'Nome vista DB',
	DOCUMENT_TEMPLATES_FIELD_FORMAT: 'Formato file',

	DIALOG_DOCUMENT_TEMPLATES_TITLE: 'Generazione documenti',
	DIALOG_DOCUMENT_TEMPLATES_EDIT_TITLE: 'Modifica Modello Carbone',
	DIALOG_CLOSING_DAYS_EDIT_TITLE: 'Modifica Giorno di Chiusura',
	DIALOG_CLOSING_DAYS_NEW_TITLE: 'Aggiungi Giorno di Chiusura',
	DIALOG_DOCUMENT_TEMPLATES_UPLOAD: 'Carica',
	DIALOG_TEMPLATES_UPLOAD_DRAG_AND_DROP: 'Trascina e rilascia un file per caricarlo',
	DIALOG_TEMPLATES_UPLOAD_AVAILABILITY: 'Il tuo template sarà disponibile per tutti gli utenti',
	DIALOG_TEMPLATES_UPLOAD_OR: 'o',
	DIALOG_TEMPLATES_UPLOAD_SELECT_FILE_BUTTON: 'Seleziona un file',
	DIALOG_TEMPLATES_UPLOAD_DROP_AREA: 'Rilascia qui',
	DIALOG_TEMPLATES_UPLOAD_FILENAME: 'File caricato',
	DIALOG_TEMPLATES_EXPORTED_SCHEDULED_TITLE: "Il tuo template è stato schedulato per l'esportazione.",
	DIALOG_TEMPLATES_EXPORTED_SCHEDULED_DESCRIPTION: 'Controlla le tue notifiche per scaricarlo quando sarà pronto.',
	// #endregion

	// #region Importables dialog
	IMPORTABLES_DIALOG_IMPORT_TITLE: 'Importazione da file Excel',
	IMPORTABLES_DIALOG_IMPORT_STEP_TEMPLATE: 'Seleziona il template',
	IMPORTABLES_DIALOG_IMPORT_STEP_UPLOAD: 'Seleziona il file',
	IMPORTABLES_DIALOG_IMPORT_STEP_IMPORT: 'Carica il file'
	// #endregion
};

export default locale;
